import React from 'react';
import {TypeImplementation, getMeta} from '@packages/systems/wfdl';
import {updateExpressionAction} from '@packages/systems/ExpressionEditor-utils';
import {
  type ContextualExpression,
  ContextualExpressions,
  stripAnn,
  getAnn,
} from '@packages/utilities/contextual-expression';
import {TText, EText} from '@packages/systems/wfdl-ast';
import TextInput from '@packages/systems/design-system/TextInput';

const OnBlurTextRender = ({
  expr,
  dispatch,
}: {
  expr: ContextualExpression;
  dispatch: TypeImplementation.ExpressionEditorDispatch;
}) => {
  const exprVal = ContextualExpressions.getText(stripAnn(expr)) || '';
  const [value, setValue] = React.useState(exprVal);
  React.useEffect(() => {
    setValue(exprVal);
  }, [exprVal]);

  const {type} = getAnn(expr);
  const meta = type ? getMeta(type) : '';
  const placeholder = meta ? meta.placeholder : '';
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setValue(e.target.value);
  const onBlur = () => dispatch(updateExpressionAction(EText(value)));
  const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') dispatch(updateExpressionAction(EText(value)));
  };

  return (
    <TextInput
      type="text"
      placeholder={placeholder}
      value={value}
      onBlur={onBlur}
      onKeyDown={handleEnter}
      onChange={onChange}
    />
  );
};

const OnBlurText = TypeImplementation.Alias({
  type: TText,
  render: OnBlurTextRender,
});

export default OnBlurText;
